<template>
	<div
		class="cco-productVariants"
		v-if="hasVariants"
		:class="
			Object.keys(this.variants).length >= 3 ? 'cco-productVariants--grid' : ''
		"
	>
		<button
			:aria-label="variant.title"
			class="cco-productVariants__variant"
			:class="{
				'cco-productVariants__variant--selected': selected.id == variant.id,
			}"
			@click="emitVariant(variant.id)"
			v-for="variant in variants"
			:key="variant.id"
		>
			<span v-if="property == 'size'">{{ variant.size }}</span>
			<span v-else-if="property == 'color'">{{ variant.color }}</span>
			<span v-else>{{ variant.title }}</span>
		</button>
	</div>
</template>

<script>
export default {
	name: 'ProductVariants',
	components: {},
	props: {
		variants: Object,
		selected: Object,
		property: String,
	},
	data: () => {
		return {
			hasVariants: false,
		};
	},
	methods: {
		emitVariant(id) {
			this.$emit('variant', id);
		},
	},
	created() {
		if (Object.keys(this.variants).length > 1) {
			this.hasVariants = true;
		}
	},
};
</script>

<style lang="scss">
@import '@backend/scss/abstracts/variables.scss';
@import '@backend/scss/abstracts/mixins.scss';

.cco-productVariants {
	display: flex;
	flex-wrap: wrap;
	gap: 16px;

	&__variant {
		height: 50px;
		padding-inline: 24px;
		border-radius: 2px;
		border: 1px solid #d2d5ed;

		cursor: pointer;
		text-transform: uppercase;

		transition: $t-hover;

		white-space: nowrap;

		&--selected,
		&:hover {
			transition: $t-hover;
			border-color: $c-blue;
		}
	}
	&--grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 10px;
	}
}

@media all and (max-width: 950px) {
	.cco-productVariants {
		display: flex;
		justify-content: center;
	}
}
</style>
